"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _BalancesButtonsComponent = _interopRequireDefault(require("../BalancesButtons/BalancesButtonsComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
require("./ProductPositionDetailsComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('product-position-details');
var ProductPositionDetailsComponent = function ProductPositionDetailsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var positionDetails = props.positionDetails,
    DepositReferenceIdModalComponent = props.DepositReferenceIdModalComponent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, props.fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    isInline: true,
    customClass: baseClasses
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-icon')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-label')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-icon')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: positionDetails.iconFileName,
    size: 48
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-symbol')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-symbol-name'),
    style: {
      color: positionDetails.productColor
    }
  }, positionDetails.Product), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('product-name')
  }, positionDetails.ProductFullName))), /*#__PURE__*/_react["default"].createElement(_BalancesButtonsComponent["default"], {
    key: "1",
    isDepositDisabled: props.isDepositDisabled,
    isWithdrawDisabled: props.isWithdrawDisabled,
    user: props.user,
    openDepositSidePane: function openDepositSidePane() {
      return props.openDepositSidePane(positionDetails);
    },
    openWithdrawSidePane: function openWithdrawSidePane() {
      return props.openWithdrawSidePane(positionDetails);
    },
    showNotificationForDeposit: props.showNotificationForDeposit,
    showNotificationForWithdraw: props.showNotificationForWithdraw
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-details')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('detail')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('label')
  }, t("Available Balance")), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('value'),
    "data-test": "Available Balance"
  }, positionDetails.AvailableBalance)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('detail')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('label')
  }, t("Hold")), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('value'),
    "data-test": "Hold"
  }, positionDetails.Hold)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('detail')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('label')
  }, t("Pending Deposits")), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('value'),
    "data-test": "Pending Deposits"
  }, positionDetails.PendingDeposits)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('detail')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('label')
  }, t("Total Balance")), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('value'),
    "data-test": "Total Balance"
  }, positionDetails.Amount))), DepositReferenceIdModalComponent));
};
ProductPositionDetailsComponent.propTypes = {
  positionDetails: _propTypes["default"].object,
  fetching: _propTypes["default"].bool.isRequired,
  user: _propTypes["default"].object.isRequired,
  openDepositSidePane: _propTypes["default"].func.isRequired,
  openWithdrawSidePane: _propTypes["default"].func.isRequired,
  isDepositDisabled: _propTypes["default"].bool,
  isWithdrawDisabled: _propTypes["default"].bool,
  showNotificationForDeposit: _propTypes["default"].func,
  showNotificationForWithdraw: _propTypes["default"].func,
  DepositReferenceIdModalComponent: _propTypes["default"].element
};
var _default = exports["default"] = ProductPositionDetailsComponent;